import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "lz-bg-gray lz-hidden lz-h-[4.375rem] lz-w-full lz-text-gray-400 lg:lz-block" }
const _hoisted_2 = { class: "lg:lz-flex lg:lz-justify-between container lz-text-sm before:lz-content-none after:lz-content-none lg:lz-h-full lg:lz-items-center" }
const _hoisted_3 = { class: "lz-flex lz-h-full lz-items-center lz-space-x-8" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "lz-flex lz-text-gray-400" }
const _hoisted_6 = { class: "lz-p-6 lz-cursor-pointer lz-relative lz-group hover:lz-text-black" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "lz-absolute lz-z-50 -lz-bottom-4 lz-left-1/2 lz-opacity-0 lz-transition-opacity lz-pointer-events-none lz-whitespace-nowrap lz-px-4 lz-py-1 lz-shadow-md -lz-translate-x-1/2 lz-bg-black lz-text-white lz-text-sm group-hover:lz-opacity-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tooltip-arrow" }),
  /*#__PURE__*/_createTextVNode(" Login ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "lz-w-px lz-bg-gray-400 lz-h-6 lz-self-center" }, null, -1)
const _hoisted_9 = { class: "lz-p-6 lz-cursor-pointer lz-relative lz-group hover:lz-text-black" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "lz-absolute lz-z-50 -lz-bottom-4 lz-left-1/2 lz-opacity-0 lz-transition-opacity lz-pointer-events-none lz-whitespace-nowrap lz-px-4 lz-py-1 lz-shadow-md -lz-translate-x-1/2 lz-bg-black lz-text-white lz-text-sm group-hover:lz-opacity-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tooltip-arrow" }),
  /*#__PURE__*/_createTextVNode(" English ")
], -1)
const _hoisted_11 = { class: "nav-safe-area lz-sticky lz-left-0 lz-top-0 lz-z-40 lz-w-full lz-bg-white lz-px-4 lz-py-6 lg:lz-p-9" }
const _hoisted_12 = { class: "lz-mx-auto lz-flex lz-items-center lg:lz-justify-between before:lz-content-none container lg:lz-h-10" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "lz-hidden lz-ml-16 lz-mr-auto lz-flex-1 lz-max-w-lg lg:lz-block"
}
const _hoisted_16 = { class: "lz-border-b lz-border-black lz-pb-2 lz-w-full lz-flex lz-items-center lz-justify-between lz-mr-auto" }
const _hoisted_17 = ["value", "onInput", "onKeydown"]
const _hoisted_18 = {
  key: 1,
  class: "lz-hidden lz-space-x-12 lg:lz-flex lg:lz-ml-16 lg:mr-4 lg:lz-flex-1"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "lz-flex lz-px-4 lz-min-h-full lz-w-full lg:lz-px-0" }
const _hoisted_22 = {
  key: 0,
  class: "lz-hidden lz-w-full lg:lz-w-auto lg:lz-pt-44 lg:lz-flex lg:lz-flex-col lg:lz-items-start"
}
const _hoisted_23 = { class: "lz-block lg:lz-pr-20" }
const _hoisted_24 = ["onMouseenter"]
const _hoisted_25 = ["href", "onMouseenter"]
const _hoisted_26 = { class: "lz-flex lz-space-x-12 lz-mt-auto lg:lz-pt-16 lg:lz-pb-20 lg:lz-text-sm" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 0,
  class: "lz-text-sm lz-w-full lg:lz-hidden"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "lz-absolute -lz-top-4 lz-h-2.5 lz-w-4 lz-overflow-hidden lz-transition-transform group-hover:lz--translate-x-2" }
const _hoisted_31 = { class: "lz-text-primary lz-text-xl lz-font-bold" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "lz-text-gray-500 lz-underline lz-font-bold mt-1" }, "Im Überblick", -1)
const _hoisted_33 = { class: "lz-block lg:lz-pr-28" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "lz-flex lz-items-center" }
const _hoisted_36 = {
  key: 0,
  class: "lz-bg-gray-100 lz-grow-0 lz-mr-5 lz-transition-colors lz-rounded-bl-lg lz-rounded-tr-lg group-hover:lz-bg-primary"
}
const _hoisted_37 = { class: "lz-relative lz-top-1 lz-ml-8 lz-h-2.5 lz-w-4 lz-overflow-hidden lz-transition-transform group-hover:lz--translate-x-2" }
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 0,
  class: "lz-bg-gray-100 lz-grow-0 lz-mr-5 lz-transition-colors lz-rounded-bl-lg lz-rounded-tr-lg group-hover:lz-bg-primary"
}
const _hoisted_40 = {
  key: 1,
  class: "lz-block lz-text-gray-500 lz-mt-6"
}
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "lz-hidden lz-bg-gray lz-w-96 lz-px-14 lg:lz-pt-44 lg:lz-block" }
const _hoisted_43 = {
  key: 0,
  class: "lz-group lz-relative lz-mb-14"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "lz-text-primary lz-mb-2 lz-text-2xl" }
const _hoisted_46 = ["href"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "lz-flex lz-items-center lz-justify-between"
}
const _hoisted_49 = { class: "lz-flex lz-items-center" }
const _hoisted_50 = {
  key: 0,
  class: "lz-bg-white lz-grow-0 lz-mr-5 lz-transition-colors lz-rounded-bl-lg lz-rounded-tr-lg group-hover:lz-bg-primary"
}
const _hoisted_51 = { class: "lz-relative lz-top-0.5 lz-ml-8 lz-h-2.5 lz-w-4 lz-overflow-hidden lz-transition-transform group-hover:lz--translate-x-2" }
const _hoisted_52 = ["href"]
const _hoisted_53 = {
  key: 0,
  class: "lz-bg-white lz-grow-0 lz-mr-5 lz-transition-colors lz-rounded-bl-lg lz-rounded-tr-lg group-hover:lz-bg-primary"
}
const _hoisted_54 = {
  key: 0,
  class: "lz-fixed lz-bottom-0 lz-left-0 lz-border-t lz-border-gray-100 lz-w-full lz-flex lz-text-black lz-h-14 lz-bg-white lg:lz-hidden"
}
const _hoisted_55 = { class: "lz-flex lz-items-center lz-p-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "lz-pl-px" }, "Login", -1)
const _hoisted_57 = { class: "lz-flex lz-items-center lz-p-4 lz-ml-5" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "lz-pl-px" }, "English", -1)
const _hoisted_59 = { class: "lz-border-b lz-border-black lz-w-full lz-flex lz-pb-2 lz-items-center lz-justify-between" }
const _hoisted_60 = ["value", "onInput", "onKeydown"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["href"]
const _hoisted_63 = ["href"]

import LzNav from '@/components/nav/LzNav.vue'
import LzNavItem from '@/components/nav/LzNavItem.vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import type { NavItem } from '@/types'
import LzIcon from '@/components/base/LzIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LzProto',
  setup(__props) {

const mainNav: Ref<NavItem[]> = ref([
    {
        title: 'Services',
        depth: 1,
        highlight: true,
        items: [
            { title: 'Consulting Digital Transformation', depth: 2 },
            { title: 'Human Centered Design', depth: 2 },
            {
                title: 'Software Engineering',
                depth: 2,
                icon: 'sites',
                link: '#',
                items: [
                    { title: 'Greenfield Project & New Digital Service', depth: 3 },
                    { title: 'Business Processes Automation', depth: 3 },
                    { title: 'Continuous Delivery & Deployment', depth: 3 },
                    { title: 'Operations & Operational Efficiency Optimisation', depth: 3 },
                    { title: 'System & Application Introductions & Migrations', depth: 3 },
                    { title: 'Multichannel Platform Solutions', depth: 3 },
                    { title: 'Legacy Transformation & Renewal Project', depth: 3 },
                    { title: 'Speedboat', depth: 3 },
                    { title: 'Low Code', depth: 3 },
                    { title: 'Technology & Security Architecture', depth: 3 }
                ]
            },
            { title: 'Cyber Security', depth: 2 },
            { title: 'Cloud Computing', depth: 2 },
            { title: 'Data & AI', depth: 2 },
            { title: 'Open Banking', depth: 2 },
            { title: 'Augumented Reality', depth: 2 },
            { title: 'Distributed Ledger Technology', depth: 2 }
        ]
    } as NavItem,
    {
        title: 'Produkte & Lösungen',
        depth: 1,
        highlight: true,
        items: [
            { title: 'Airlock® Secure Access Hub', depth: 2, icon: 'sites' },
            { title: 'Finanzlösungen', depth: 2 },
            { title: 'BIM-to-Field-Augmented', depth: 2 },
            { title: 'Inventory Management System', depth: 2 }
        ]
    },
    { title: 'Über uns', depth: 1, highlight: true },
    { title: 'Branchen', depth: 1 },
    { title: 'Referenzen', depth: 1 },
    { title: 'Karriere', depth: 1 }
])

const topNav = ref([
    { title: 'Jobs', link: '#' },
    { title: 'News', link: '#' },
    { title: 'Kontakt', link: '#' }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topNav.value, (top, i) => {
            return (_openBlock(), _createElementBlock("a", {
              key: `top-${i}`,
              href: top.link,
              class: "lz-transition-colors hover:!lz-text-black"
            }, _toDisplayString(top.title), 9, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(LzIcon, {
              name: "login",
              class: "lz-fill-current lz-w-4 lz-h-4"
            }),
            _hoisted_7
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(LzIcon, {
              name: "sites",
              class: "lz-fill-current lz-w-4 lz-h-4"
            }),
            _hoisted_10
          ])
        ])
      ])
    ]),
    _createVNode(LzNav, null, {
      default: _withCtx(({
                isOpen,
                homeLink,
                toggle,
                toggleSearch,
                searchOpen,
                searchValue,
                setSearch,
                search,
                items
            }: {
                items: NavItem[],
                isOpen: boolean,
                homeLink: string,
                searchOpen: boolean,
                searchValue: string,
                search: (query: string) => void,
                setSearch: (value: string) => void,
                toggle: (event: MouseEvent | PointerEvent, index?: number) => void,
                toggleSearch: () => void
            }) => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: _normalizeClass(["lz-order-3 lz-ml-5 lz-flex lz-h-6 lz-w-6 lz-shrink-0 lz-items-center lz-justify-center lz-transition-colors lg:lz-order-none lg:lz-ml-0", { 'lz-p-0.5': isOpen }]),
              onClick: toggle
            }, [
              _createVNode(LzIcon, {
                name: isOpen ? 'close' : 'burger',
                class: "lz-h-full lz-w-full"
              }, null, 8, ["name"])
            ], 10, _hoisted_13),
            _createElementVNode("a", {
              href: homeLink,
              class: "lz-block lz-order-1 -lz-mb-4 lz-h-7 lz-w-24 lz-shrink-0 lg:lz-order-none lg:lz-h-10 lg:lz-w-32 lg:lz-ml-8"
            }, [
              _createVNode(LzIcon, {
                name: "logo",
                class: "lz-h-full lz-w-full"
              })
            ], 8, _hoisted_14),
            searchOpen
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("input", {
                      value: searchValue,
                      onInput: ($event: any) => (setSearch($event.target.value)),
                      onKeydown: _withKeys(($event: any) => (search(`/author/de/searchResult?query=${encodeURI(searchValue)}`)), ["enter"]),
                      type: "text",
                      class: "lz-bg-transparent lz-flex-1",
                      placeholder: "Suchbegriff eingeben"
                    }, null, 40, _hoisted_17),
                    _createVNode(LzIcon, {
                      onClick: ($event: any) => (search(`/author/de/searchResult?query=${encodeURI(searchValue)}`)),
                      name: "search",
                      class: _normalizeClass([{ 'lz-fill-primary': searchValue.length }, "lz-cursor-pointer lz-h-5 lz-w-5 lz-shrink-0 lz-ml-4"])
                    }, null, 8, ["onClick", "class"])
                  ])
                ]))
              : (items && items.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.filter((x) => x.highlight), (mainItem, m) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${mainItem.title}#main`,
                        onClick: ($event: any) => (toggle($event, m)),
                        class: "hover:lz-text-primary lz-cursor-pointer lz-text-2xl"
                      }, _toDisplayString(mainItem.title), 9, _hoisted_19))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: toggleSearch,
              class: "lz-order-2 lz-ml-auto lz-flex lz-h-6 lz-w-6 lz-p-0.5 lz-shrink-0 lz-items-center lz-justify-center lz-transition-colors lg:lz-order-none lg:lz-ml-0"
            }, [
              _createVNode(LzIcon, {
                name: searchOpen ? 'close' : 'search',
                class: "lz-h-full lz-w-full"
              }, null, 8, ["name"])
            ], 8, _hoisted_20)
          ])
        ])
      ]),
      nav: _withCtx(({ item, items, mobile, navigate, showItems, back, isBack }) => [
        _createElementVNode("div", _hoisted_21, [
          items
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("ul", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (itm, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: 'nav#' + i,
                      class: _normalizeClass([[
                                    itm.highlight ? 'lz-mb-10 lz-font-bold lz-text-xl lg:lz-text-5xl' : 'lz-mb-6 lg:lz-text-2xl lg:lz-font-normal',
                                    { 'lg:lz-mt-16': !itm.highlight && i > 0 && items[i - 1].highlight }
                                ], "hover:lz-text-primary lz-group lz-cursor-pointer lg:lz-w-96"])
                    }, [
                      (itm.items && itm.items.length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onMouseenter: ($event: any) => (navigate(i, true)),
                            class: "lz-flex lz-items-center lz-justify-between"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["lz-w-full lz-flex lz-justify-between lz-items-center", {
                                            'lz-text-primary': itm.title === item.title
                                        }])
                            }, [
                              _createTextVNode(_toDisplayString(itm.title) + " ", 1),
                              _createElementVNode("div", {
                                class: _normalizeClass([[itm.title === item.title ? 'lz-opacity-100' : 'lz-opacity-0'], "lz-relative lz-top-1 lz-ml-8 lz-h-4 lz-w-7 lz-shrink-0 lz-overflow-hidden lz-transition-opacity"])
                              }, [
                                _createVNode(LzIcon, {
                                  name: "arrow",
                                  class: "lz-absolute lz-right-0 lz-h-4 lz-w-10 lz-fill-primary"
                                })
                              ], 2)
                            ], 2)
                          ], 40, _hoisted_24))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: itm.link,
                            onMouseenter: ($event: any) => (navigate(i, true)),
                            class: _normalizeClass({
                                        'lg:lz-pr-16': itm.depth === 1
                                    })
                          }, _toDisplayString(itm.title), 43, _hoisted_25))
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topNav.value, (metaItem, m) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: `${metaItem.link}-mt-${m}`,
                      href: metaItem.link
                    }, _toDisplayString(metaItem.title), 9, _hoisted_27))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            name: isBack ? 'slide-left-to-right' : 'slide-right-to-left'
          }, {
            default: _withCtx(() => [
              (mobile.items && mobile.items.length && showItems)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (mobile.depth > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "lz-group lz-relative lz-mb-6 lz-cursor-pointer",
                          onClick: back
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(LzIcon, {
                              name: "arrow",
                              class: "lz-h-2 lz-w-7 lz-rotate-180 lz-fill-gray-600"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(mobile.title), 1),
                          _hoisted_32
                        ], 8, _hoisted_29))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobile.items, (itm, m) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: 'nav#' + m,
                          class: _normalizeClass([{
                                    'lz-font-bold lz-mb-5 lz-pb-5 lz-text-xl lz-border-b lz-border-gray-100': itm.highlight && itm.depth === 1,
                                    'lz-text-lg lz-mb-3': !itm.highlight && itm.depth === 1
                                }, "hover:lz-text-primary lz-group lz-cursor-pointer"])
                        }, [
                          (itm.items && itm.items.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: ($event: any) => (navigate(m, false, true)),
                                class: _normalizeClass([{ 'lz-border-b lz-border-gray-100 lz-py-5': itm.depth > 1 }, "lz-flex lz-items-center lz-justify-between"])
                              }, [
                                _createElementVNode("div", _hoisted_35, [
                                  (itm.icon)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createVNode(LzIcon, {
                                          name: itm.icon,
                                          class: "lz-w-4 lz-h-4 lz-m-3 lz-fill-gray-300 group-hover:lz-fill-gray-100"
                                        }, null, 8, ["name"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(itm.title), 1)
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(LzIcon, {
                                    name: "arrow",
                                    class: "lz-absolute lz-right-0 lz-h-2 lz-w-7 lz-fill-current"
                                  })
                                ])
                              ], 10, _hoisted_34))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: itm.link,
                                class: _normalizeClass(["lz-flex lz-items-center", {
                                        'lz-border-b lz-border-gray-100 lz-py-5': itm.depth > 1
                                    }])
                              }, [
                                (itm.icon)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createVNode(LzIcon, {
                                        name: itm.icon,
                                        class: "lz-w-4 lz-h-4 lz-m-3 lz-fill-gray-300 group-hover:lz-fill-gray-100"
                                      }, null, 8, ["name"])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(itm.title), 1)
                              ], 10, _hoisted_38))
                        ], 2))
                      }), 128))
                    ]),
                    (mobile.depth === 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topNav.value, (top, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `top-mobile-${i}`,
                              class: "lz-mb-3"
                            }, [
                              _createElementVNode("a", {
                                href: top.link
                              }, _toDisplayString(top.title), 9, _hoisted_41)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["name"]),
          _createElementVNode("div", _hoisted_42, [
            (item.depth === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", {
                    onClick: back,
                    class: "lz-absolute lz-cursor-pointer -lz-top-6 lz-h-2.5 lz-w-4 lz-overflow-hidden lz-transition-transform hover:-lz-translate-x-2"
                  }, [
                    _createVNode(LzIcon, {
                      name: "arrow",
                      class: "lz-h-2 lz-w-7 lz-rotate-180 lz-fill-gray-500"
                    })
                  ], 8, _hoisted_44),
                  _createElementVNode("div", _hoisted_45, _toDisplayString(item.title), 1),
                  (item.link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: item.link,
                        class: "lz-text-gray-500 lz-underline lz-font-bold mt-1 hover:lz-underline"
                      }, " Im Überblick ", 8, _hoisted_46))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", {
              class: _normalizeClass([item.depth === 1 ? 'lg:lz-text-base' : 'lg:lz-text-sm'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (subItem, s) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `sub#${subItem.title}`,
                  onClick: ($event: any) => (navigate(s)),
                  class: "hover:lz-text-primary lz-group lz-mb-6 lz-cursor-pointer lz-border-b lz-border-gray-600 lz-border-opacity-30 lz-pb-6"
                }, [
                  (subItem.items && subItem.items.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          (subItem.icon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createVNode(LzIcon, {
                                  name: subItem.icon,
                                  class: "lz-w-5 lz-h-5 lz-m-4 lz-fill-gray-300 group-hover:lz-fill-gray-100"
                                }, null, 8, ["name"])
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(subItem.title), 1)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(LzIcon, {
                            name: "arrow",
                            class: "lz-absolute lz-right-0 lz-h-2 lz-w-7 lz-fill-current"
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: subItem.link,
                        class: "lz-flex lz-items-center lz-group"
                      }, [
                        (subItem.icon)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createVNode(LzIcon, {
                                name: subItem.icon,
                                class: "lz-w-5 lz-h-5 lz-m-4 lz-fill-gray-300 group-hover:lz-fill-gray-100"
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(subItem.title), 1)
                      ], 8, _hoisted_52))
                ], 8, _hoisted_47))
              }), 128))
            ], 2)
          ])
        ])
      ]),
      sitenav: _withCtx(({ item }) => [
        (item.depth === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createVNode(LzIcon, {
                  name: "login",
                  class: "lz-fill-current lz-mr-2 lz-w-4 lz-h-4"
                }),
                _hoisted_56
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(LzIcon, {
                  name: "sites",
                  class: "lz-fill-current lz-mr-2 lz-w-4 lz-h-4"
                }),
                _hoisted_58
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      search: _withCtx(({ searchValue, setSearch, search }: { searchValue: string, setSearch: (value: string) => void, search: (query: string) => void }) => [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("input", {
            value: searchValue,
            onInput: ($event: any) => (setSearch($event.target.value)),
            onKeydown: _withKeys(($event: any) => (search(`/author/de/searchResult?query=${encodeURI(searchValue)}`)), ["enter"]),
            type: "text",
            class: "lz-bg-transparent lz-flex-1",
            placeholder: "Suchbegriff eingeben"
          }, null, 40, _hoisted_60),
          _createElementVNode("div", {
            onClick: ($event: any) => (search(`/author/de/searchResult?query=${encodeURI(searchValue)}`)),
            class: _normalizeClass(["lz-cursor-pointer lz-h-6 lz-w-6 lz-shrink-0 lz-ml-4", { 'lz-text-primary': searchValue.length }])
          }, [
            _createVNode(LzIcon, {
              name: "search",
              class: "lz-w-full lz-h-full lz-fill-current"
            })
          ], 10, _hoisted_61)
        ])
      ]),
      registration: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainNav.value, (navItem) => {
          return (_openBlock(), _createBlock(LzNavItem, {
            key: navItem.title,
            title: navItem.title,
            link: navItem.link,
            highlight: navItem.highlight,
            depth: navItem.depth
          }, _createSlots({
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: navItem.link
              }, _toDisplayString(navItem.title), 9, _hoisted_62)
            ]),
            _: 2
          }, [
            (navItem.items && navItem.items.length)
              ? {
                  name: "items",
                  fn: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItem.items, (subItem) => {
                      return (_openBlock(), _createBlock(LzNavItem, {
                        key: subItem.title,
                        title: subItem.title,
                        icon: subItem.icon,
                        depth: subItem.depth,
                        link: subItem.link
                      }, _createSlots({
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: subItem.link
                          }, _toDisplayString(subItem.title), 9, _hoisted_63)
                        ]),
                        _: 2
                      }, [
                        (subItem.items && subItem.items.length)
                          ? {
                              name: "items",
                              fn: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.items, (subSubItem) => {
                                  return (_openBlock(), _createBlock(LzNavItem, {
                                    key: subSubItem.title,
                                    title: subSubItem.title,
                                    depth: subSubItem.depth,
                                    link: subSubItem.link
                                  }, null, 8, ["title", "depth", "link"]))
                                }), 128))
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["title", "icon", "depth", "link"]))
                    }), 128))
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["title", "link", "highlight", "depth"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})